import { Link } from 'react-router-dom';

const Disclaimer = () => {
  return (
    <div>
      <section className="py-16 md:py-24" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <h1
            className="text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-bold mb-8"
            style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
            data-testid="disclaimer-heading"
          >
            Disclaimer
          </h1>
          <p className="text-sm mb-8" style={{ color: '#94A3B8' }}>
            Last updated: April 2026
          </p>

          <article className="space-y-8" data-testid="disclaimer-content">
            <div
              className="p-6 border-l-4"
              style={{ borderColor: '#FF5722', backgroundColor: '#FFF4E6' }}
            >
              <p className="text-base leading-relaxed font-semibold" style={{ color: '#0A0F1A' }}>
                Important Notice
              </p>
              <p className="text-base leading-relaxed mt-2" style={{ color: '#475569' }}>
                Dhanamm (dhanamm.com) is partnered with Angel One for Demat account openings, Mutual Funds, Insurance, and other financial products selling. We are not a SEBI registered company and we do not provide any advisory from our side. We only work as a middlemen who transit Angel One advisories, resolve your technical app related issues such as buying, selling, profile updates, etc. Our Sub Broker code is <strong style={{ color: '#0A0F1A' }}>MNUL</strong> and we use Angel One's SEBI license and work along with Angel One.
              </p>
            </div>

            <div
              className="p-6 border-l-4"
              style={{ borderColor: '#EF4444', backgroundColor: '#FEF2F2' }}
            >
              <p className="text-base leading-relaxed font-semibold" style={{ color: '#EF4444' }}>
                Report Misuse
              </p>
              <p className="text-base leading-relaxed mt-2" style={{ color: '#475569' }}>
                If anyone is misusing the name Dhanamm or the MNUL sub broker code for stock market advisory, tips, portfolio management, or any other illegal activities, kindly inform SEBI (Securities and Exchange Board of India) or other related legal bodies immediately.
              </p>
              <p className="text-base mt-2" style={{ color: '#475569' }}>
                <strong style={{ color: '#0A0F1A' }}>SEBI Helpline:</strong> 1800 266 7575 | <strong style={{ color: '#0A0F1A' }}>SEBI SCORES:</strong> scores.gov.in
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                1. No Investment Advisory
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Dhanamm is not a SEBI registered Investment Adviser, Research Analyst, or Portfolio Manager. We do not provide any buy/sell recommendations, stock tips, or investment advice. Any information, articles, or content on this website is purely for educational and informational purposes and should not be construed as investment advice.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                2. Our Role as Sub Broker
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Dhanamm operates as an authorised sub-broker of Angel One under the sub broker code <strong style={{ color: '#0A0F1A' }}>MNUL</strong>. Our role is limited to:
              </p>
              <ul className="space-y-2 ml-4 mt-3">
                <li className="text-base" style={{ color: '#475569' }}>Facilitating the opening of Demat and Trading accounts with Angel One.</li>
                <li className="text-base" style={{ color: '#475569' }}>Assisting clients with technical issues related to the Angel One app and platform.</li>
                <li className="text-base" style={{ color: '#475569' }}>Helping with buying, selling, profile updates, and other operational queries.</li>
                <li className="text-base" style={{ color: '#475569' }}>Transmitting advisory and research provided by Angel One to clients.</li>
                <li className="text-base" style={{ color: '#475569' }}>Facilitating Mutual Fund, Insurance, and other financial product applications through Angel One.</li>
              </ul>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                3. Market Risk Disclaimer
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Investments in securities market are subject to market risks. Read all the related documents carefully before investing. The past performance of securities, mutual funds, or any financial instrument is not indicative of future results. There is no assurance or guarantee that the objectives of any investment will be achieved.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                4. Mutual Fund Disclaimer
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Mutual Fund investments are subject to market risks. Read all scheme-related documents carefully before investing. Past performance is not an indicator of future returns. The NAV of the units issued under the schemes may go up or down depending on various factors and forces affecting the securities market.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                5. Insurance Disclaimer
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Insurance is the subject matter of solicitation. Dhanamm acts as a facilitator for insurance products offered through Angel One's platform. Please read all policy documents and terms carefully before purchasing any insurance product. Tax benefits are subject to changes in tax laws.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                6. Accuracy of Information
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                While we strive to keep the information on this website accurate and up-to-date, we make no warranties or representations of any kind about the completeness, accuracy, reliability, or suitability of the information. Brokerage charges, plans, and features mentioned on this website are indicative and may change as per Angel One's policies.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                7. Angel One Registration Details
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Angel One Limited (formerly known as Angel Broking Limited) is a registered member of NSE, BSE, and MCX. CIN: L67120MH1996PLC101709. SEBI Registration No.: INZ000161534. Research Analyst: INH000000164. Investment Adviser: INA000008172. AMFI Reg. No.: ARN-77404. PFRDA Registration No.: 19092018. For more details, visit <a href="https://www.angelone.in" target="_blank" rel="noopener noreferrer" style={{ color: '#FF5722' }}>www.angelone.in</a>.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                8. Contact Information
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                For any concerns, complaints, or queries, please reach out to us:
              </p>
              <p className="text-base mt-2" style={{ color: '#475569' }}>
                <strong style={{ color: '#0A0F1A' }}>Dhanamm</strong><br />
                <strong style={{ color: '#0A0F1A' }}>Sub Broker Code:</strong> MNUL<br />
                <strong style={{ color: '#0A0F1A' }}>Email:</strong> angeloneblr@gmail.com<br />
                <strong style={{ color: '#0A0F1A' }}>Phone:</strong> +91 99023 00787<br />
                <strong style={{ color: '#0A0F1A' }}>Angel One SEBI Registration No:</strong> 1N2000161534<br />
                <strong style={{ color: '#0A0F1A' }}>Address:</strong> AECS Layout, A Block, Singasandra, Bangalore 560068
              </p>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
};

export default Disclaimer;
